import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import { dashboardActions } from "../../../_actions";
import Table from "../Component/Table";
import AddUpdateModal from "../Component/AddUpdateModal";
import moment from "moment/moment";
import { HiPlus, HiSearch, HiChevronDown, HiChevronLeft, HiChevronRight, HiOutlineBookOpen } from 'react-icons/hi';
import { LuDownload, LuPlus, LuSearch, LuChevronLeft, LuChevronRight, } from 'react-icons/lu';


class ReadingRolePlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChapter: 0,
      openAddNewModal: false,
      formData: {
        name: "",
        desc: ""
      },
      searchQuery: "",

      pageNo: 1,
      size: 10,
      keyWord: ""
    };
  }

  componentDidMount() {
    let data = {
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.getRolePlayList(data));
  }

  setChapter = (index) => {
    this.setState({ activeChapter: index });
  };

  /* ---------------- CREATE ---------------- */

  createRolePlay = () => {
    let { formData } = this.state;
    let data = {
      name: formData.name,
      desc: formData.desc
    }
    let temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.createRolePlay(data, temp));
    this.onClose()
  };

  /* ---------------- UPDATE ---------------- */

  updateRolePlay = (data) => {
    this.props.dispatch(dashboardActions.updateRolePlay(data));
  };

  /* ---------------- DELETE ---------------- */

  deleteRolePlay = (id) => {
    if (window.confirm("Are you sure you want to delete this case study?")) {
      this.props.dispatch(
        dashboardActions.deleteRolePlay({ rolePlayId: id })
      );
    }
  };

  /* ---------------- EDIT REDIRECT ---------------- */

  onEdit = (item) => {
    this.props.history.push("/insightadmin/roleplaydetails/" + item.rolePlayId);
  };

  createNew = () => {
    this.setState({ openAddNewModal: true })
  }

  onClose = () => {
    this.setState({ openAddNewModal: false })
  }

  handleChange = (e) => {
    let { formData } = this.state;
    formData[e.target.name] = e.target.value;
    this.setState({ formData })
  }

  onDelete = () => {

  }



  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(dashboardActions.getRolePlayList(data));
  }


  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getRolePlayListTotal } = this.props.dashboard;
    const totalPages = Math.ceil(getRolePlayListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };



  render() {
    let { activeChapter, openAddNewModal, formData, pageNo, size } = this.state;
    let { dashboard } = this.props;
    let { getRolePlayListData = [], getRolePlayListTotal } = dashboard;

    const list = getRolePlayListData && getRolePlayListData.length > 0 ? getRolePlayListData.map((ele, i) => ({
      sno: i + 1,
      rolePlayId: ele.id,
      name: ele.name,
      desc: ele.desc,
      createdAt: moment(ele.createdAt)
        .format("DD MMM, YYYY")
    })) : []

    const columns = [
      { label: "S.No", key: "sno" },
      { label: "Name", key: "name" },
      { label: "Desc", key: "desc" },
      { label: "Created At", key: "createdAt" },
    ];

    const start = getRolePlayListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getRolePlayListTotal);
    const totalPages = Math.ceil(getRolePlayListTotal / size);


    return (
      <LayoutWrap>
        <div className="h-full flex bg-white">
          <div className="w-full mx-auto bg-white p-4 sm:p-6">

            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-5 gap-4">
              <h1 className="text-xl sm:text-2xl font-medium textblack">
                Case Study Library
              </h1>

              <button
                onClick={() => this.createNew()}
                className="flex items-center gap-2 bg-indigo-600 text-white px-4 sm:px-6 py-2 rounded-md font-medium hover:bg-indigo-700 transition-colors"
              >
                <HiPlus className="text-lg sm:text-xl" />
                Add New
              </button>
            </div>

            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
              <div className="flex items-center gap-2 text-sm textblack">
                Show
                <select
                  className="border border-gray-300 bg-white outline-none rounded-md px-2 py-1 font-semibold"
                  value={this.state.size} onChange={this.handleSizeChange}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                Entries
              </div>

              {/* Right */}
              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">

                {/* SEARCH */}
                <div className="relative w-full sm:w-64">
                  <LuSearch
                    className="absolute left-3 top-1/2 -translate-y-1/2 textblack"
                    size={16}
                  />
                  <input
                    type="text"
                    value={this.state.keyWord}
                    onChange={this.handleSearch}
                    placeholder="Search..."
                    className="w-full pl-9 pr-3 py-2 border border-gray-300 textblack placeholder:text-gray-800 rounded-md text-sm outline-none"

                  />
                </div>

                {/* PAGINATION */}
                <div className="flex items-center gap-3 text-sm textblack">
                  <span>{start}-{end}  of {getRolePlayListTotal}</span>
                  <div className="flex gap-1">
                    <button onClick={this.goPrev} disabled={this.state.pageNo === 1} className="p-1 border rounded">
                      <LuChevronLeft size={18} />
                    </button>
                    <button onClick={this.goNext} disabled={this.state.pageNo === totalPages} className="p-1 border rounded bg-purple-50 text-indigo-600">
                      <LuChevronRight size={18} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* TABLE WRAPPER (IMPORTANT) */}
            <div className="w-full overflow-x-auto">
              <div className="min-w-[800px]">

                {/* Header Row */}
                <div className="grid grid-cols-12 bg-indigo-100 px-4 py-3 rounded-t-lg mb-2 textblack font-semibold text-xs sm:text-sm">
                  <div className="col-span-5 sm:col-span-4">Name</div>
                  <div className="col-span-3 sm:col-span-4"></div>
                  <div className="col-span-2 text-center">Created</div>
                  <div className="col-span-2 text-center">Action</div>
                </div>

                {/* Table Body */}
                <div className="space-y-2 pb-6">
                  {list && list.length > 0 ? (
                    list.map((item) => (
                      <div
                        key={item.id}
                        className="grid grid-cols-12 items-center p-3 sm:p-4 border border-gray-300 rounded-xl hover:shadow-md transition-shadow"
                      >

                        {/* Name */}
                        <div className="col-span-5 sm:col-span-4 flex items-center gap-3 min-w-0">
                          <div className="p-2 sm:p-3 bg-indigo-100 rounded-lg flex-shrink-0">
                            <HiOutlineBookOpen className="text-indigo-600 text-lg sm:text-2xl" />
                          </div>

                          <span className="font-semibold textblack text-sm sm:text-base truncate">
                            {item.name}
                          </span>
                        </div>

                        {/* Empty / Desc */}
                        <div className="col-span-3 sm:col-span-4 textblack text-xs sm:text-sm truncate pr-2">
                          {""}
                        </div>

                        {/* Date */}
                        <div className="col-span-2 text-center textblack text-xs sm:text-sm whitespace-nowrap">
                          {item.createdAt}
                        </div>

                        {/* Actions */}
                        <div className="col-span-2 flex justify-center gap-2 sm:gap-3">
                          <button
                            onClick={() => this.onEdit(item)}
                            className="p-2 sm:p-2.5 bg-indigo-100 text-indigo-600 rounded-lg hover:bg-indigo-200 border"
                          >
                            <FiEdit3 className="text-base sm:text-lg" />
                          </button>

                          <button className="p-2 sm:p-2.5 bg-red-50 text-red-500 rounded-lg hover:bg-red-100 border">
                            <FiTrash2 className="text-base sm:text-lg" />
                          </button>
                        </div>

                      </div>
                    ))
                  ) : (
                    <div className="flex items-center justify-center h-32 textblack text-base">
                      Data not available!
                    </div>
                  )}
                </div>

              </div>
            </div>

          </div>

          {/* Modal */}
          {openAddNewModal && (
            <AddUpdateModal
              onClose={this.onClose}
              formData={formData}
              type={"Create"}
              handleChange={this.handleChange}
              onSubmit={this.createRolePlay}
            />
          )}
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(ReadingRolePlay);
